// ENUMS #############################################################
import { TssVariant } from '@app/modules/tss/models/tss.model';

export enum TssEntityTooltipIdentifierEnum {
	ACTIVATION_DATE = 'activationDate',
	ASSIGNMENT_TYPE = 'assignmentType',
	BSI_ID = 'bsiId',
	CREATED_DATE = 'createdDate',
	DEACTIVATION_DATE = 'deactivationDate',
	DEVICE_TYPE = 'deviceType',
	FCC_ID = 'fccId',
	FCC_INSTALLATION_TYPE = 'fccInstallationType',
	FCC_VERSION = 'fccVersion',
	FINAL_UPLOAD_RECEIVED_DATE = 'finalUploadReceivedDate',
	LAST_MODIFIED_DATE = 'lastModifiedDate',
	MODE = 'mode',
	MODE_SUB_TYPE = 'modeSubtype',
	NAME = 'name',
	PROVIDED_BY = 'providedBy',
	STATUS = 'status',
	TSS_SERIAL_NUMBER = 'tssSerialNumber',
	VERSION = 'version',
	VERSION_UPDATE_DATE = 'versionUpdateDate'
}

// CONSTANTS #########################################################


// TYPES #############################################################


// INTERFACES ########################################################
export interface ITssEntityTooltipConfig {
	allowedTssIdentifiers: TssEntityTooltipIdentifierEnum[];
	dateTimeFormat: Intl.DateTimeFormatOptions;
}

export interface ITssEntityTooltipConfigAll extends ITssEntityTooltipConfig {
	tss: TssVariant;
}

export interface ITssEntityTooltipItem {
	identifier: TssEntityTooltipIdentifierEnum;
}


// ENTITIES ##########################################################

